import * as React from "react";
const SvgFiRrFireFlameSimple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fire-flame-simple_svg__a)">
      <path
        fill="#062147"
        d="m15.526 11.456-1.78-1.734a2.49 2.49 0 0 0-3.483-.002l-1.798 1.745A4.97 4.97 0 0 0 7 15c0 1.336.52 2.592 1.465 3.535A4.97 4.97 0 0 0 12 20a4.97 4.97 0 0 0 3.535-1.465A4.97 4.97 0 0 0 17 15a4.97 4.97 0 0 0-1.465-3.535zm-1.406 5.665c-1.13 1.135-3.107 1.133-4.241 0A2.98 2.98 0 0 1 8.999 15c0-.802.313-1.555.869-2.11l1.788-1.735a.496.496 0 0 1 .695 0l1.774 1.729c.564.566.875 1.317.875 2.117s-.313 1.554-.88 2.12m5.63-11.927-3.943-3.642A5.41 5.41 0 0 0 12-.001a5.4 5.4 0 0 0-3.786 1.533L4.222 5.22c-4.29 4.291-4.29 11.269 0 15.558A10.93 10.93 0 0 0 12 24c2.937 0 5.7-1.145 7.778-3.222 4.289-4.289 4.289-11.268-.028-15.584m-1.386 14.17A8.95 8.95 0 0 1 12 22a8.95 8.95 0 0 1-6.364-2.636c-3.51-3.51-3.51-9.219-.028-12.701l3.984-3.681a3.446 3.446 0 0 1 4.837.02l3.936 3.634c3.509 3.51 3.509 9.219 0 12.729z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fire-flame-simple_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireFlameSimple;
